export const ExportedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 11.5L21.2 3.30005"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 7.3V2.5H17.2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2.5H9C4 2.5 2 4.5 2 9.5V15.5C2 20.5 4 22.5 9 22.5H15C20 22.5 22 20.5 22 15.5V13.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.6225 25.2525L21 35.875L10.3775 25.2525"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 6.125V35.5775"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const VlLockIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27.0003 39.0374C29.0258 39.0374 30.6678 37.3954 30.6678 35.3699C30.6678 33.3444 29.0258 31.7024 27.0003 31.7024C24.9748 31.7024 23.3328 33.3444 23.3328 35.3699C23.3328 37.3954 24.9748 39.0374 27.0003 39.0374Z"
      fill="#4A5FF7"
    />
    <path
      d="M41.13 21.4425V18.63C41.13 12.555 39.6675 4.5 27 4.5C14.3325 4.5 12.87 12.555 12.87 18.63V21.4425C6.57 22.23 4.5 25.425 4.5 33.2775V37.4625C4.5 46.6875 7.3125 49.5 16.5375 49.5H37.4625C46.6875 49.5 49.5 46.6875 49.5 37.4625V33.2775C49.5 25.425 47.43 22.23 41.13 21.4425ZM27 42.165C23.2425 42.165 20.205 39.105 20.205 35.37C20.205 31.6125 23.265 28.575 27 28.575C30.735 28.575 33.795 31.635 33.795 35.37C33.795 39.1275 30.7575 42.165 27 42.165ZM16.5375 21.24C16.3575 21.24 16.2 21.24 16.02 21.24V18.63C16.02 12.0375 17.8875 7.65 27 7.65C36.1125 7.65 37.98 12.0375 37.98 18.63V21.2625C37.8 21.2625 37.6425 21.2625 37.4625 21.2625H16.5375V21.24Z"
      fill="#4A5FF7"
    />
  </svg>
);

export const VlQuoteIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="109"
    height="80"
    viewBox="0 0 109 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26.8193 80C21.979 80 17.8445 79.1078 14.416 77.3234C11.1891 75.539 8.56723 73.0607 6.55042 69.8885C4.53361 66.9145 3.02101 63.3457 2.01261 59.1822C1.0042 54.8203 0.5 50.7559 0.5 46.9888C0.5 37.0756 3.02101 28.0545 8.06303 19.9256C13.3067 11.5985 21.2731 4.95662 31.9622 0L34.6849 5.35316C28.8361 7.73234 23.6933 11.4994 19.2563 16.6543C15.021 21.8092 12.5 27.0632 11.6933 32.4163C11.0882 36.1834 11.1891 39.653 11.9958 42.8253C16.0294 38.86 21.1723 36.8773 27.4244 36.8773C33.8782 36.8773 39.2227 38.7608 43.458 42.5279C47.6933 46.2949 49.8109 51.6481 49.8109 58.5874C49.8109 64.9319 47.5924 70.0867 43.1555 74.052C38.7185 78.0173 33.2731 80 26.8193 80ZM85.5084 80C80.6681 80 76.5336 79.1078 73.105 77.3234C69.8781 75.539 67.2563 73.0607 65.2395 69.8885C63.2227 66.9145 61.7101 63.3457 60.7017 59.1822C59.6933 54.8203 59.1891 50.7559 59.1891 46.9888C59.1891 37.0756 61.7101 28.0545 66.7521 19.9256C71.9958 11.5985 79.9622 4.95662 90.6513 0L93.3739 5.35316C87.5252 7.73234 82.3823 11.4994 77.9454 16.6543C73.7101 21.8092 71.1891 27.0632 70.3824 32.4163C69.7773 36.1834 69.8782 39.653 70.6849 42.8253C74.7185 38.86 79.8613 36.8773 86.1134 36.8773C92.5672 36.8773 97.9118 38.7608 102.147 42.5279C106.382 46.2949 108.5 51.6481 108.5 58.5874C108.5 64.9319 106.282 70.0867 101.845 74.052C97.4076 78.0173 91.9622 80 85.5084 80Z"
      fill="#4A5FF7"
    />
  </svg>
);
